// src/components/AuthNav.jsx
import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../firebase";

export default function AuthNav(props) {
  const location = useLocation();
  const navigate = useNavigate();

  // 接收外部传入的 active（比如 Dashboard 传 "member"）
  var active = "";
  if (props && props.active) {
    active = props.active;
  }

  // 把 /、/login、/auth 看成会员入口页
  var isLoginPage =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/auth";

  // Members 按钮是否高亮
  var isMemberActive = false;
  if (isLoginPage) {
    isMemberActive = true;
  }
  if (active === "member") {
    isMemberActive = true;
  }

  // 点击 Members 逻辑
  function handleMemberClick() {
    // 已登录：去 Dashboard
    if (auth && auth.currentUser) {
      navigate("/dashboard");
    } else {
      // 未登录 / 非会员：去注册入口
      navigate("/auth?mode=signup");
    }
  }

  // 统一生成 NavLink 的 className，避免写三遍
  function navLinkClass(navData) {
    if (navData && navData.isActive) {
      return "auth-nav-link auth-nav-link-active";
    }
    return "auth-nav-link";
  }

  return (
    <div className="auth-nav">
      <div className="auth-nav-right">
        {/* 1. Members 会员（自定义跳转逻辑） */}
        <button
          type="button"
          className={
            "auth-nav-link" + (isMemberActive ? " auth-nav-link-active" : "")
          }
          onClick={handleMemberClick}
        >
          Members 会员
        </button>

        {/* 2. Menu 菜单 */}
        <NavLink to="/menu" className={navLinkClass}>
          Menu 菜单
        </NavLink>

        {/* 3. Contact 联络 */}
        <NavLink to="/contact" className={navLinkClass}>
          Contact 联络
        </NavLink>

        {/* 4. About 关于 */}
        <NavLink to="/about" className={navLinkClass}>
          About 关于
        </NavLink>
      </div>
    </div>
  );
}